import { Button } from './Button'
import { Keyboard } from 'lucide-react'

interface HotkeysHelpProps {
  onClose: () => void
}

const hotkeys = [
  { key: 'N', description: '添加新书签' },
  { key: 'F', description: '聚焦搜索框' },
  { key: 'ESC', description: '清除搜索/取消选择' },
  { key: 'Ctrl + A', description: '全选书签' },
  { key: 'Del', description: '删除选中的书签' },
  { key: '空格', description: '选择/取消选择书签' },
]

export function HotkeysHelp({ onClose }: HotkeysHelpProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-medium flex items-center">
            <Keyboard className="w-5 h-5 mr-2" />
            键盘快捷键
          </h2>
          <Button variant="ghost" size="sm" onClick={onClose}>
            ×
          </Button>
        </div>
        <div className="space-y-3">
          {hotkeys.map(({ key, description }) => (
            <div key={key} className="flex items-center justify-between">
              <span className="text-gray-600">{description}</span>
              <kbd className="px-2 py-1 text-sm font-semibold bg-gray-100 border border-gray-200 rounded">
                {key}
              </kbd>
            </div>
          ))}
        </div>
        <div className="mt-6 text-sm text-gray-500">
          提示：在输入框中时快捷键将被禁用
        </div>
      </div>
    </div>
  )
} 